import { useRouter } from 'vue-router';

import Api from '@/api/Api';

import { useUserStore } from '@/stores/user';
import { useRoversStore } from '@/stores/rovers';

export function useLogout() {
    const userStore = useUserStore();
    const roversStore = useRoversStore();
    const router = useRouter();
    const onLogout = () => {
        Api.logout();
        userStore.logout();
        roversStore.logout();
        router.push({ name: 'home' });
    };
    return {
        onLogout,
    };
}
